module.exports = __webpack_public_path__ + "static/media/Mutt.62de513e.jpg";